var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 44 44"}},[_c('circle',{attrs:{"cx":"22","cy":"22","r":"22","fill":"var(--status-svg-color)","fill-rule":"evenodd"}}),_c('path',{attrs:{"fill":"none","stroke":"#fff","stroke-width":"1.5","d":"M15 14h4v16h-4zM25 14h4v16h-4z"}})])
}
var staticRenderFns = []

export default { render: render }